import { useAppSelector } from "@/shared/lib/redux"
import { selectFlight } from "../../model"
import { Fragment } from "react"
import { selectAirlinesMap, selectAirportsMap, TransporterIcon } from "@/entities/aviabooking-reference"
import { formatDuration } from "@/entities/flight"
import { format, getDay, getMonth } from "date-fns"
import { monthsGenitive } from "@/shared/consts/month-names"
import { dayShortNames } from "@/shared/consts/day-names"
import TransferSVG from '@/shared/assets/images/ArrowsLeftRight.svg'

export const FlightDetails = () => {
    const flight = useAppSelector(selectFlight)
    const airports = useAppSelector(selectAirportsMap)
    const airlines = useAppSelector(selectAirlinesMap)

    return (
        <div>
            <div className="font-bold text-2xl">
                {airports[flight.dep_airport_code]?.city} → {airports[flight.arr_airport_code]?.city}
            </div>
            <div className="text-slate-500 text-base mb-4">
                {formatDuration(flight.total_duration)} в пути
            </div>
            <div className="bg-white rounded-3xl p-4">
                {flight.segments.map((segment, index) =>
                    <Fragment key={index}>
                        <div className="px-3">
                            <div className="flex gap-4 items-center mb-4">
                                <TransporterIcon
                                    name={airlines[segment.marketing_airline]?.name}
                                    icon={airlines[segment.marketing_airline]?.logo}
                                />
                                <div className="flex justify-center flex-col">
                                    <div className="font-bold text-lg">
                                        {airlines[segment.marketing_airline]?.name}
                                    </div>
                                    <div className="font-normal -mt-[2px] text-base text-slate-500">
                                        {formatDuration(segment.flight_time)} в в полете
                                    </div>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex mr-6">
                                    <div className="w-[18px] mt-[6px] h-[18px] rounded-full relative border-[5px] border-slate-400">
                                        <div className="h-[44px] bg-slate-300 w-[4px] ml-[2px] top-[13px] absolute"/>
                                    </div>
                                </div>
                                <div className="flex gap-6 items-center">
                                    <div className="flex justify-center flex-col mb-3">
                                        <div className="font-bold text-lg">
                                            {format(segment.dep_date_time, "HH:mm")}
                                        </div>
                                        <div className="font-normal -mt-[2px] text-base text-slate-500">
                                            {format(segment.dep_date_time, "d")} {monthsGenitive[getMonth(segment.dep_date_time)].slice(0, 3).toLowerCase()}, {dayShortNames[getDay(segment.dep_date_time)].toLowerCase()}
                                        </div>
                                    </div>
                                    <div className="flex justify-center flex-col">
                                        <div className="font-bold text-lg">
                                            {airports[segment.dep_airport_code]?.city}
                                        </div>
                                        <div className="font-normal -mt-[2px] text-base text-slate-500">
                                            {airports[segment.dep_airport_code]?.name || airports[segment.dep_airport_code]?.city}, {airports[segment.dep_airport_code]?.code}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="col-span-2 flex mt-[6px] mr-6">
                                    <div className="w-[18px] h-[18px] rounded-full border-[5px] border-slate-400" />
                                </div>
                                <div className="flex gap-6 items-center">
                                    <div className="flex justify-center flex-col mb-3">
                                        <div className="font-bold text-lg">
                                            {format(segment.arr_date_time, "HH:mm")}
                                        </div>
                                        <div className="font-normal -mt-[2px] text-base text-slate-500">
                                            {format(segment.arr_date_time, "d")} {monthsGenitive[getMonth(segment.arr_date_time)].slice(0, 3).toLowerCase()}, {dayShortNames[getDay(segment.arr_date_time)].toLowerCase()}
                                        </div>
                                    </div>
                                    <div className="flex justify-center flex-col">
                                        <div className="font-bold text-lg">
                                            {airports[segment.arr_airport_code]?.city}
                                        </div>
                                        <div className="font-normal -mt-[2px] text-base text-slate-500">
                                            {airports[segment.arr_airport_code]?.name || airports[segment.arr_airport_code]?.city}, {airports[segment.arr_airport_code]?.code}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {index !== (flight.segments?.length - 1) &&
                            <div className="my-4 py-2 px-3 rounded-lg w-full bg-slate-100 flex">
                                <div className="col-span-2 flex items-center mr-[18px]">
                                    <TransferSVG width={24} height={24} />
                                </div>
                                <div className="flex justify-center flex-col">
                                    <div className="font-bold text-lg">
                                        Пересадка
                                    </div>
                                    <div className="font-normal -mt-[2px] text-base text-slate-500">
                                        {airports[segment.arr_airport_code]?.name || airports[segment.arr_airport_code]?.city}, {airports[segment.arr_airport_code]?.code}
                                    </div>
                                </div>
                            </div>
                        }
                    </Fragment>
                )}
            </div>
        </div>
    )
}